import React from 'react';
import { H3 } from '~/shared/Typography';
import { HStack } from 'native-base';
import { useHomePageStyles } from '~/shared/styles';
import { SpIcon } from '~/shared/Icon';
import {
    faShareAlt,
    faGem,
    faDollarSign,
    faTrophy,
    faAward,
    faGift,
    faComment,
} from '@fortawesome/free-solid-svg-icons';

type CardTitleProps = {
    title: string;
    icon?:
        | 'faShareAlt'
        | 'faGem'
        | 'faDollarSign'
        | 'faTrophy'
        | 'faAward'
        | 'faGift'
        | 'faComment'
    ;
};

const icons = {
    faShareAlt,
    faGem,
    faDollarSign,
    faTrophy,
    faAward,
    faGift,
    faComment,
};

export const CardTitle = ({
    title,
    icon,
}: CardTitleProps) => {

    const { pressable_text, icon: iconColor } = useHomePageStyles();

    return (
        <HStack space={2} alignItems={'center'} alignSelf={'center'} mb={2}>
            <H3
                color={pressable_text}
                fontWeight={500}
            >
                { title }
            </H3>
            { icon &&
                <SpIcon icon={icons[icon]} color={iconColor} size={24} />
            }
        </HStack>
    );
};
